import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=2e24dfe4&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"
import style0 from "./settings.vue?vue&type=style&index=0&id=2e24dfe4&prod&scoped=true&lang=scss"
import style1 from "./settings.vue?vue&type=style&index=1&id=2e24dfe4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e24dfe4",
  null
  
)

export default component.exports